import instance from "../utils.ts/instance"

export const excuteAxiosPost = async (url: string, params: any) => {
    return await 
        instance.post(
            url, params
        )
}